import { DEFAULT_AUTH_HOST } from './constants';
import { generateEnvDomain } from './generateEnvDomain';
import { envAutoDetector } from "./envAutoDetector";

// Функция для проверки, что URL безопасен для редиректа
export const isSafeRedirectUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url, window.location.origin);
    const isSecureProtocol = parsedUrl.protocol === 'https:';

    const currentEnvDomain = envAutoDetector();
    const isAllowedDomain = parsedUrl.hostname.endsWith(`.${currentEnvDomain}`);

    const noJavascriptInUrl = !parsedUrl.href.includes('javascript:');

    return isSecureProtocol && isAllowedDomain && noJavascriptInUrl;
  } catch (e) {
    return false;
  }
};

// Функция для генерации базового URL для редиректа
export const generateRedirectUrl = (path: string, origin = window.location.origin) => {
  const authHost = process.env.REACT_APP_UNIONE_COMMONS_AUTH_HOST || generateEnvDomain(DEFAULT_AUTH_HOST);
  const encodeUrl = encodeURIComponent(origin);
  return `${authHost}${path}?redirect=${encodeUrl}`;
};